var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.ssidsFormatted},scopedSlots:_vm._u([{key:"cell(action)",fn:function(row){return [_c('DeleteSsidIcon',{staticClass:"float-right",attrs:{"ssid":row.item.ssid}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }